/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/require-default-props */
import React from 'react';
import dynamic from 'next/dynamic';
import { Common } from '@stockbit/ui';

import Image from 'global/Image';
import { StreamPostData } from '../../../../@types/stream';
import { StreamEntryPoint } from '../types';

import { StreamBoxContainer } from '../Post/styled';
import TextContent from '../TextContent';
import { nonSourceNews as NON_SOURCE } from '../constants';
import {
  ContentBox,
  NewsWrapper,
  Thumbnail,
  ThumbnailBox,
  TitleContent,
} from './styled';

const Footer = dynamic(() => import('../Post/Footer'), {
  ssr: false,
  loading: () => <div />,
});

const { Flex, Text } = Common;

interface PostProps {
  post?: StreamPostData;
  onComment?: () => void;
  hasFollowingActivity?: boolean;
  isFirstPost?: boolean;
  isSinglePost?: boolean;
  highlightWord?: string;
  entryPoint: StreamEntryPoint;
  symbol?: string;
  dataCyName?: string;
}

const PostNews = ({ post, onComment }: PostProps) => {
  const {
    content,
    created_display,
    images,
    mask_html,
    newsfeed_img,
    newsfeed_label,
    title,
    titleurl,
    username,
  } = post;

  const imagesData: string[] =
    images?.length > 0 && images[0] !== '' ? images : [];

  const isHaveImage = Boolean(imagesData?.length > 0);
  const thumbnailImage: string = isHaveImage && imagesData[0];

  let hasMoreLine = false;
  let labelText = newsfeed_label;
  let labelImage = newsfeed_img;
  if (!labelText) {
    // News in a special case - from manual HQ
    const newsUsername = username?.toLowerCase();
    labelText = NON_SOURCE[newsUsername]?.label;
    hasMoreLine = NON_SOURCE[newsUsername]?.extend;
    labelImage = NON_SOURCE[newsUsername]?.image;
  }

  const textContent = content.replace(/(\n|\r\n)/g, '');

  return (
    <StreamBoxContainer>
      <NewsWrapper
        href={titleurl}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e: MouseEvent) => {
          if (!titleurl) {
            e.preventDefault();
            onComment();
          }
        }}
      >
        <ContentBox>
          <TitleContent size="18px" family="bold" hasMoreLine={hasMoreLine}>
            {title}
          </TitleContent>

          {titleurl && (
            <Flex onClick={(e: MouseEvent) => e.stopPropagation()}>
              <TextContent
                isRepost
                content={textContent}
                maskedHtml={mask_html}
                className="content-text"
                style={{ margin: '0px' }}
              />
            </Flex>
          )}

          <Flex>
            <Image
              alt={labelText}
              src={labelImage}
              style={{ width: '16px', height: '16px', marginRight: '4px' }}
            />
            <Text size="12px" color="#969696">
              {labelText}
              <Text as="span" padding="0px 4px" color="#969696">
                •
              </Text>
              {created_display}
            </Text>
          </Flex>
        </ContentBox>

        {isHaveImage && (
          <ThumbnailBox>
            <Thumbnail src={thumbnailImage} alt="Stockbit" />
          </ThumbnailBox>
        )}
      </NewsWrapper>

      <Footer post={post} onComment={onComment} hideLikers />
    </StreamBoxContainer>
  );
};

export default PostNews;
